import { render, staticRenderFns } from "./AddNewOperators.vue?vue&type=template&id=145d1588&scoped=true"
import script from "./AddNewOperators.vue?vue&type=script&lang=js"
export * from "./AddNewOperators.vue?vue&type=script&lang=js"
import style0 from "./AddNewOperators.vue?vue&type=style&index=0&id=145d1588&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145d1588",
  null
  
)

export default component.exports